import { clsx } from "clsx"
import { ReactNode } from "react"
import "./style.sass"
interface TabItem {
  title: ReactNode
  icon?: ReactNode
  to?: string
}
interface Props {
  active?: TabItem
  tabs: TabItem[]
}
export const Tab = ({ tabs, active }: Props) => {
  return (
    <div className="custom-tab">
      {tabs.map((tab) => (
        <div
          className={clsx("custom-tab__item", {
            "custom-tab__item--active": active === tab,
          })}
        >
          {tab.icon}
          {tab.title}
        </div>
      ))}
    </div>
  )
}
